module.exports = __webpack_public_path__ + "media/images/countrysquared/cw-43bb9b6f595da35a0cf219095de5a35e.svg";